import axios from "axios";

export function isAbortError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;

  const err = error as { name?: string; code?: string; message?: string };

  return (
    axios.isCancel(error) ||
    err.name === "AbortError" ||
    err.name === "CanceledError" ||
    err.code === "ERR_CANCELED"
  );
}
